import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { TooltipButton } from 'common/react/components/tooltip-button';
import { getTranslation } from 'common/react/utils/translations';

export const TBCRoundTooltip = ({ roundId }) => {
    const label =
        getTranslation(`label.fixtures.tbcTooltip.${roundId}`) ||
        getTranslation('label.fixtures.tbcTooltip');
    const title =
        getTranslation(`label.fixtures.tbcTooltipTitle.${roundId}`) ||
        getTranslation('label.fixtures.tbcTooltipTitle');
    const content =
        getTranslation(`label.fixtures.tbcTooltipContent.${roundId}`) ||
        getTranslation('label.fixtures.tbcTooltipContent');

    return (
        <TooltipButton
            title={label}
            classNames={{
                component: 'fixtures__tbc-tooltip-wrapper',
                button: 'fixtures__tbc-tooltip-button'
            }}
            direction="below"
            primaryTooltipContent={
                <div className="fixtures__tbc-tooltip-content">
                    {title ? (
                        <h3 className="fixtures__tbc-tooltip-title">{title}</h3>
                    ) : (
                        ''
                    )}
                    <p className="fixtures__tbc-tooltip-text">{content}</p>
                </div>
            }
            id={`tbc-explainer-${roundId}`}
        >
            <SvgIcon
                icon="help-circle"
                className="fixtures__tbc-tooltip-icon"
            />
            {label}
        </TooltipButton>
    );
};

TBCRoundTooltip.propTypes = {
    roundId: PropTypes.string
};
